import { Switch } from '@headlessui/react';
import React, { useState } from 'react';
import { TopicStyles } from '../mixins/mixins';
import { String } from 'aws-sdk/clients/batch';

type styleMenuDropdownProps = {
	handleChange: (value: string) => void;
	name: string;
	options: {
		name: string;
		value: string;
	}[];

	optionState: string;
};

export const StyleDropdownMenu = ({
	handleChange,
	name,
	options,
	optionState
}: styleMenuDropdownProps) => {
	return (
		<div className="w-40 mb-8">
			<label
				about={name}
				className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
			>
				{name}
			</label>
			<select
				id={name}
				className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
				onChange={(e) => {
					console.log('targer', e.target.value);
					handleChange(e.target.value);
				}}
			>
				{options.map((item) => (
					<option selected={optionState == item.value} value={item.value}>
						{item.name}
					</option>
				))}
			</select>
		</div>
	);
};

// Slider

type StyleSlideProps = {
	id: string;
	name: string;
	initialValue?: number | string;
	minValue: string;
	maxValue: string;
	step: string;
	handleChange: (value: any) => void;
};

export const StyleSlider = ({
	id,
	name,
	initialValue,
	minValue,
	maxValue,
	step,
	handleChange
}: StyleSlideProps) => {
	const handler = (e: any) => handleChange({ value: e.target.value });

	return (
		<div className="w-40 mb-8">
			<label
				htmlFor="default-range"
				className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
			>
				{name}
			</label>
			<input
				key={id}
				id={id}
				step={step}
				type="range"
				defaultValue={initialValue}
				onMouseUp={handler}
				min={minValue}
				max={maxValue}
				className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
			/>
		</div>
	);
};

// Toggle

type StyleToggleProps = {
	styleKey: string;
	name: string;
	optionState?: boolean;

	style: TopicStyles;
	parentStyle: any;
	styleObj: any;
	setStyle: (style: any) => void;
};

export const StyleToggle = ({
	styleKey,
	name,
	optionState,
	parentStyle,
	style,
	styleObj,
	setStyle
}: StyleToggleProps) => {
	const [enabled, setEnabled] = useState(
		optionState != null ? optionState : false
	);

	const handleChange = () => {
		setEnabled(!enabled);
		setStyle({
			...style,
			[styleObj]: { ...parentStyle, [styleKey]: !enabled }
		});
	};

	return (
		<div className="w-40 mb-8">
			<label
				about={name}
				className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
			>
				{name}
			</label>
			<Switch
				checked={enabled}
				onChange={handleChange}
				className={`${
					enabled ? 'bg-blue-600' : 'bg-gray-600'
				} relative inline-flex h-6 w-11 items-center rounded-full`}
			>
				<span
					className={`${
						enabled ? 'translate-x-6' : 'translate-x-1'
					} inline-block h-4 w-4 transform rounded-full bg-gray-200 transition-all ease-in-out duration-200`}
				/>
			</Switch>
		</div>
	);
};

// Input

type styleInputProps = {
	handleChange: (value: string) => void;
	name: string;
	optionState?: string;
	placeholder: string;
};

export const StyleInupt = ({
	handleChange,
	name,
	placeholder,
	optionState
}: styleInputProps) => {
	return (
		<div className="w-8/12">
			<h3 className="block mb-2 text-sm font-medium text-gray-800 dark:text-gray-300">
				{name}
			</h3>
			<input
				type="text"
				id="name"
				className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
				placeholder={placeholder}
				required
				defaultValue={optionState}
				onBlur={(e: any) => {
					handleChange(e.target.value);
				}}
			/>
		</div>
	);
};
